/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDocInternalInfoRequest } from '../types/PatchedDocInternalInfo';
import type { DocInternalInfoResponse } from '../types/DocInternalInfo';

export type DocsInternalInfoPartialUpdateRequest = PatchedDocInternalInfoRequest;
export type DocsInternalInfoPartialUpdateResponse = DocInternalInfoResponse;

export type DocsInternalInfoPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/docs/{id}/internal_info/
 *
 * ```yaml
 * operationId: docs_internal_info_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocInternalInfo'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocInternalInfo'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocInternalInfo'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocInternalInfo'
 *     description: ''
 * ```
 */
export const docsInternalInfoPartialUpdateOperation = ({
  id,
  ...rest
}: DocsInternalInfoPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/docs/${id}/internal_info/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/docs/{id}/internal_info/' };
  };

/**
 * PATCH /dmx-server/docs/{id}/internal_info/
 *
 * ```yaml
 * operationId: docs_internal_info_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocInternalInfo'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocInternalInfo'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDocInternalInfo'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DocInternalInfo'
 *     description: ''
 * ```
 */
export const docsInternalInfoPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocsInternalInfoPartialUpdateQuery;
  request: PatchedDocInternalInfoRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DocInternalInfoResponse>> => {
  const operation = docsInternalInfoPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
